import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import SalaryAdjustRow from './SalaryAdjustRow';
import SalaryCreateRow from './SalaryCreateRow';

class SalaryAdjustModal extends Component {
  render() {
    let {dispatch, adjustList, adjustmentTypeList, dimissAdjustSalary} = this.props;

    return (
      <Modal.Dialog className="salary__modal">
        <Modal.Body>
          <div className="header">
            <h3>
              借糧/花紅
            </h3>
          </div>
          <table className="table salary__modal__table">
            <tbody>
              {adjustList.entrySeq().map(([id, data]) => {
                let adjust = {
                  id: id,
                  amount: data.get('amount'),
                  typeID: data.get('typeID'),
                  note: data.get('note'),
                }

                return (
                  <SalaryAdjustRow
                    adjustmentTypeList={adjustmentTypeList}
                    dispatch={dispatch}
                    {...adjust} />
                )
              })}
              <SalaryCreateRow
                adjustmentTypeList={adjustmentTypeList}
                dispatch={dispatch} />
            </tbody>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={dimissAdjustSalary}>關閉</Button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

export default SalaryAdjustModal;



// WEBPACK FOOTER //
// ./src/components/Salary/SalaryAdjustModal.js